import { useEffect, useRef } from 'react'

import { useVisitorChannelContext } from '@liveHelper/context/VisitorChannelContext'
import {
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'

import { useDocumentFocus } from '@core/hooks/useDocumentFocus'

/**
 * Updates the visitor status when they move to a tab on a different website, or
 * when the browser is unfocused.
 */
export const useUpdateActiveStatus = () => {
  const { updateActiveStatus } = useStore(visitorPrivateActionsSelector)
  const isDocumentFocused = useDocumentFocus()
  const isDocumentFocusedRef = useRef(isDocumentFocused)

  const channel = useVisitorChannelContext()

  useEffect(() => {
    isDocumentFocusedRef.current = isDocumentFocused
  }, [isDocumentFocused])

  useEffect(() => {
    if (!channel) {
      return
    }

    if (isDocumentFocused) {
      updateActiveStatus?.(true)
    } else {
      // Do not update status to inactive until a timeout has passed and
      // isDocumentFocused is still false, that way we prevent flickering when
      // tabs are switched back and forth quickly.
      const timeout = setTimeout(() => {
        if (!isDocumentFocusedRef.current) {
          updateActiveStatus?.(false)
        }
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [channel, isDocumentFocused, updateActiveStatus])
}
